import {ENDPOINT_DISASTER_AREA} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const getDisasterAreas = (token, ddId) => {
  return fetch(`${ENDPOINT_DISASTER_AREA}declarations/${ddId}/designated-area`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

export default {
  getDisasterAreas,
};
